import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  componentDidCatch(error, info) { console.error('APP CRASH:', error.message, info); }
  static getDerivedStateFromError(error) { return { error: error.message }; }
  render() {
    if (this.state.error) return (
      <div style={{position:'fixed',inset:0,background:'#0A0E1A',color:'#FF4F6A',padding:20,fontSize:14,zIndex:999,display:'flex',flexDirection:'column',justifyContent:'center'}}>
        <div style={{fontWeight:700,marginBottom:8}}>Erreur détectée :</div>
        <div>{this.state.error}</div>
        <div style={{marginTop:16,display:'flex',gap:10}}>
          <button onClick={()=>this.setState({error:null})} style={{padding:'8px 16px',background:'#00D4AA',border:'none',borderRadius:8,cursor:'pointer',color:'#000',fontWeight:700}}>Réessayer</button>
          <button onClick={()=>window.location.reload()} style={{padding:'8px 16px',background:'transparent',border:'1px solid #FF4F6A',borderRadius:8,cursor:'pointer',color:'#FF4F6A',fontWeight:700}}>Recharger la page</button>
        </div>
      </div>
    );
    return this.props.children;
  }
}

export default ErrorBoundary;
